import { Observable } from 'rxjs';
import { PostSendContactFormRequest } from '../Models/Requests/PostSendContactFormRequest';
import { ApiClientService } from './api-client.service';
import { Inject, inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { PostSendContactFormResponse } from '../Models/Responses/PostSendContactFormResponse';
import { PostRequestCallbackRequest } from '../Models/Requests/PostRequestCallbackRequest';
import { AppConfigInterface } from '../../config/app.config.interface';
import { APP_CONFIG } from '../../app.config';

@Injectable({
  providedIn: 'root',
})
export class FormService {
  private readonly apiService = inject(ApiClientService);
  private readonly httpClient = inject(HttpClient);

  constructor(
    @Inject(APP_CONFIG) private config: AppConfigInterface,
  ) {}

  public sendContactForm(form: PostSendContactFormRequest) : Observable<PostSendContactFormResponse> {
    if (form.file) {
      const formData = new FormData();
      formData.append('subjectIdHash', form.subjectIdHash);
      formData.append('message', form.message);
      formData.append('file', form.file);
      return this.httpClient.post<PostSendContactFormResponse>(this.config.apiURL + `api/contacts/contact-form-2/`, formData);
    }

    const params = {
      subjectIdHash: form.subjectIdHash,
      message: form.message,
    };

    return this.httpClient.post<PostSendContactFormResponse>(this.config.apiURL + 'api/v2/contacts/contact-form/', params);
  }

  public requestCallback(request: PostRequestCallbackRequest) : Observable<PostSendContactFormResponse> {
    const params = {
      caseIdHash: request.caseIdHash,
      callbackDate: request.callbackDate.toISOString(),
      phoneIdHash: request.phoneIdHash,
    };

    return this.apiService.post<PostSendContactFormResponse>('api/v2/contacts/callback/', false, params);
  }
}


